module.exports = __webpack_public_path__ + "static/media/v2.c1cbd35.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work2/v2.mp4
// module id = QWJ6
// module chunks = 0